import React, { useState, useEffect, useContext, useRef } from "react"
import { message, Table, Flex, Config, Button } from "antd"
import { UserContext, useUser } from "../contexts/UserContext"
import { getAccounts } from "../api/Cards/users"
import "./AccountManagement.css"
import { useTranslation } from "react-i18next"
import AccountEditorModal from "./AccountEditorModal"

const AccountManager = () => {

    const { user } = useContext(UserContext)
    const { getToken, isAdmin, getRole } = useUser()
    const [accountList, setAccountList] = useState([
        {
            Name: "Test1",
            Address: "TestAddr",
            Phone: "TestPhone",
            Role: "TestRole",
            UserID: 1,
            Children: [{
                    Name: "Test3",
                    Address: "TestAddr",
                    Phone: "TestPhone",
                    Role: "TestRole",
                    UserID: 3,
                Children: [{
                    Name: "Test5",
                    Address: "TestAddr",
                    Phone: "TestPhone",
                    Role: "TestRole",
                    UserID: 5,
                    Children: []
                },
                {
                    Name: "Test6",
                    Address: "TestAddr",
                    Phone: "TestPhone",
                    Role: "TestRole",
                    UserID: 6,
                    Children: []
                }]
                },
                {
                    Name: "Test4",
                    Address: "TestAddr",
                    Phone: "TestPhone",
                    Role: "TestRole",
                    UserID: 4,
                    Children: []
                }]
        },
        {
            Name: "Test2",
            Address: "TestAddr",
            Phone: "TestPhone",
            Role: "TestRole",
            UserID: 2,
            Children: []
        }


    ])
    const { t } = useTranslation()
    const [showModal, setShowModal] = useState(false)
    const isOrg = useRef(false)
    const currentUser = useRef(null)
    const [messageApi, contextHolder] = message.useMessage()


    async function loadAccounts() {
        const data = await getAccounts(getToken())
        setAccountList(data);
    }

    useEffect(() => {
        loadAccounts();
    }, [])


    const columns = [
        {
            title: t("Namn"),
            dataIndex: "AccountName",
            key: "name",
            fixed:true,
            sorter: (a, b) => a.name && b.name && a.name.localeCompare(b.name)
        },
        {
            title: t("Address"),
            dataIndex: "Address",
            key: "address",
            fixed: true,
            width: "300px",
            render: (Address) => (<div style={{ width: "300px" }}>{Address}</div>)
        },
        {
            title: t("Telefon"),
            dataIndex: "Phone",
            key: "phone",
            fixed: true,
            width: "150px",
            render: (Phone) => (<div style={{ width: "150px" }}>{Phone}</div>)
        },
        {
            title: t("Roll"),
            dataIndex: "Role",
            key: "role",
            fixed: true,
            width: "100px",
            render: (Role, Item) => (<div style={{ width: "100px" }}>{getRoleName(Role, Item.UserID)}</div>)
        },
        {
            title: "",
            dataIndex: "UserID",
            key: "modify",
            fixed: true,
            width: "100px",
            render: (UserID, Item) => (<div style={{ width: "100px" }}>{((user.roleId == 3 || (Item.Role < user.roleId) && Item.Role >= 0)) && Item.UserID > 0 && (<Button onClick={() => { (Item.Role == -1 ? isOrg.current = true : isOrg.current = false); currentUser.current = Item; setShowModal(true) }}>{t('page.accountmanager.modify')}</Button>)}</div>)
        }
    ]

    const tableLocale = {
        triggerDesc: t('page.sort.falling'),
        triggerAsc: t('page.sort.rising'),
        cancelSort: t('page.sort.none')
    }

    /*
    
    View:
        -Organization(s)
            -Admins
                -Resellers
                    -Users
        Data:
            Entry name
            UserID
            Address
            Phone number
            EMail
            Role

    */

    function findEntry(UserID, items) {
        if (!items)
            return null

        items.forEach((item, index) => {
            if (UserID == item.UserID)
                return item;

            //Search subtree
            var Subtree = findEntry(UserID, item.Children)
            if (Subtree != null)
                return Subtree
        })

        return null;
    }

    const expandRow = (item) => {

        return renderTable(item.Children)
    }

    function hasChildren(entries) {
        if (entries == null)
            return false

        for (var i = 0; i < entries.length; ++i) {
            if (entries[i].Children != null && entries[i].Children.length > 0)
                return true;
        }

        return false;
    }

    function getRoleName(Role, UserId) {
        if (UserId < 0)
            return "";

        return t("page.general.roles." + Role);
    }

    const renderTable = (entries) => {

        if (entries == null)
            return (<div></div>);

        return (
            <Table
            style={{padding:"0"}}
            rowKey="UserID"
            columns={columns}
            dataSource={entries}
            pagination={false}
            showHeader={entries == accountList ? true : false}
            expandable={
                hasChildren(entries) ? 
                {
                    expandedRowClassName:"no-padding",
                    expandedRowRender: expandRow,
                    expandRowByClick: true,
                    showExpandColumn: true
                } :
                {
                    expandedRowClassName: "no-padding",
                    expandRowByClick: false,
                    showExpandColumn: false
                }
            }
            locale={tableLocale}
        />)
    }

    return (
        <>
            {contextHolder}
            {showModal && (<AccountEditorModal messageApi={messageApi} onClose={() => { setShowModal(false); loadAccounts(); }} selectedAccount={currentUser.current} isOrg={isOrg.current}></AccountEditorModal>)}
            {renderTable(accountList)}
            
        </>
    )
}

export default AccountManager;